import type { CtcaeVersion } from "../types";
import type { EncoderModelSpec, PrecomputedIndexSource } from "./types";

export const CTCAE_DENSEON_V8_P5_Q4F16_MODEL: EncoderModelSpec = {
  key: "ctcae-denseon-unified-v8-p5-q4f16",
  label: "DenseOn unified-v8 · P5 · Q4F16",
  modelId: "models/ctcae-denseon-unified-v8-p5-q4f16",
  revision: "local-20260815-denseon-v8-p5",
  device: "auto",
  dtype: "q4f16",
  local: true,
  queryPrefix: "query: ",
  documentPrefix: "document: ",
  artifactManifestUrl: "/models/ctcae-denseon-unified-v8-p5-q4f16/artifact-manifest.json",
  artifactSha256: "6f3ceadc443c9617e04b0a330e31f23bec50199c21ef5a9455464b80403f54d7",
  artifactBytes: 146_965_473,
  rankingArtifactSha256: "4b3c577741e57f81b6e59bc862ab29306eaa5edd65442c32b20334570794b86f",
};

export const PRODUCTION_MODEL = CTCAE_DENSEON_V8_P5_Q4F16_MODEL;
export const DEFAULT_MODEL = PRODUCTION_MODEL;

export const MODEL_PRESETS = [CTCAE_DENSEON_V8_P5_Q4F16_MODEL] as const;

export const PRODUCTION_INDEX_ROOT = "/models/ctcae-denseon-unified-v8-p5-q4f16/index";

export const PRECOMPUTED_INDEXES: Record<CtcaeVersion, PrecomputedIndexSource> = {
  "5.0": {
    manifestUrl: `${PRODUCTION_INDEX_ROOT}/v5.json`,
    matrixUrl: `${PRODUCTION_INDEX_ROOT}/v5.bin`,
  },
  "6.0": {
    manifestUrl: `${PRODUCTION_INDEX_ROOT}/v6.json`,
    matrixUrl: `${PRODUCTION_INDEX_ROOT}/v6.bin`,
  },
};
